import { useMemo } from 'react'
import { ObjectType, SitemodelContextValue } from 'sitemodel/shared/types'

type UseSitemodelContentProps = {
  sitemodelContent: string | ObjectType[] | undefined
}

const useSitemodelContent = ({
  sitemodelContent
}: UseSitemodelContentProps): SitemodelContextValue => {
  return useMemo(() => {
    if (!sitemodelContent) {
      return {}
    }

    if (typeof sitemodelContent === 'object') {
      return sitemodelContent
    }

    if (typeof sitemodelContent === 'string') {
      return JSON.parse(sitemodelContent)
    }

    return {}
  }, [sitemodelContent])
}

export default useSitemodelContent
